import { Component, Inject, OnInit, EventEmitter, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderService } from '../../../../../services/order/order.service';
import { ShippingStatus } from '@pdqdev/pdq-shared/dist/CarrierData';
import { DeliveryTransaction } from '@app/sharedModule/models/delivery-transaction.model';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-holddialog',
  templateUrl: './holddialog.component.html',
  styleUrls: ['./holddialog.component.scss'],
  standalone: false,
})
export class HolddialogComponent implements OnInit {
  @Output() actionResponse = new EventEmitter<{ deliveryTransaction: DeliveryTransaction; id: string }>();
  selectedIds = [];
  selectedOrderNumbers = [];
  state: string;
  preText: string;
  postText: string;
  dontDisplayOrderNumbers: boolean;
  displayOrderNumbersOnly: boolean;
  isLoading;
  title: string;
  confirmLabel: string;
  constructor(
    public dialogRef: MatDialogRef<HolddialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private orderService: OrderService,
  ) {}
  ngOnInit() {
    this.data['rows'].map((order) => {
      this.selectedIds.push(order?.id);
      this.selectedOrderNumbers.push(order?.orderNumber);
    });
    this.state = this.data['state'];
    this.preText = this.data['preText'];
    this.postText = this.data['postText'];
    this.dontDisplayOrderNumbers = this.data['dontDisplayOrderNumbers'];
    this.displayOrderNumbersOnly = this.data['displayOrderNumbersOnly'] || false;
    this.initTitle();
    this.confirmLabel = this.getConfirmLabel();
  }
  onAction() {
    this.isLoading = true;
    switch (this.state) {
      case 'Pause orders': {
        this.orderService.holdOrders(this.selectedIds).then(() => {
          this.dialogRef.close();
        });
        break;
      }
      case 'Unpause': {
        this.orderService.unHoldOrders(this.selectedIds).then(() => {
          this.dialogRef.close();
        });
        break;
      }
      case 'Unsnooze order': {
        this.orderService.unScheduleOrders(this.selectedIds).then(() => {
          this.dialogRef.close();
        });
        break;
      }
      case 'DELIVERED': {
        //available only 1 order per click for now
        this.orderService.updateStatus(this.selectedIds?.pop(), ShippingStatus.DELIVERED).then((result) => {
          if (result?.deliveryTransaction) {
            this.actionResponse.emit(result);
          }
          this.dialogRef.close();
        });
        break;
      }
      case 'Subscribe to plan': {
        this.dialogRef.close(true);
      }
      case 'Unmerge': {
        this.orderService
          .unmergeOrders(this.selectedIds)
          .pipe(
            catchError((error) => {
              this.dialogRef.close({
                message: `Failed to un-merge order${
                  this.selectedOrderNumbers?.length < 2 ? '' : 's'
                }. Try again or reach out to support`,
                mode: 'danger',
              });
              return error;
            }),
          )
          .subscribe(() => {
            this.dialogRef.close({
              message: `${this.selectedIds.length} order${this.selectedOrderNumbers?.length < 2 ? '' : 's'} un-merged`,
              mode: 'info',
            });
          });
        break;
      }
    }
  }

  initTitle() {
    const isSingle = this.selectedOrderNumbers?.length < 2;
    switch (this.state) {
      case 'Pause orders': {
        this.title = isSingle ? 'Pause order' : this.state;
        this.postText = `${this.postText} but ${
          isSingle ? 'the delivery promise' : 'their delivery promises'
        } won’t be affected. You can always move ${isSingle ? 'it' : 'them'} back to the Ready tab later.`;
        break;
      }
      case 'Unpause': {
        this.title = isSingle ? 'Unpause order' : `Unpause orders`;
        break;
      }
      case 'Unsnooze order': {
        this.title = isSingle ? 'Unsnooze order' : `Unsnooze orders`;
        break;
      }
      case 'Unmerge': {
        this.title = isSingle ? 'Unmerge order' : `Unmerge orders`;
        break;
      }
      default: {
        this.title = this.state;
      }
    }
  }

  getStateLabel() {
    switch (this.state) {
      case 'Pause orders': {
        return this.selectedOrderNumbers?.length < 2
          ? 'Pause order'
          : `Pause ${this.selectedOrderNumbers?.length} orders`;
      }
      case 'Unpause': {
        return this.selectedOrderNumbers?.length < 2
          ? 'Unpause'
          : `Unpause ${this.selectedOrderNumbers?.length} orders`;
      }
      case 'Unmerge': {
        return this.selectedOrderNumbers?.length < 2
          ? 'Un-merge order'
          : `Un-merge ${this.selectedOrderNumbers?.length} orders`;
      }
    }
    return this.state;
  }
  getConfirmLabel() {
    switch (this.state) {
      case 'Pause orders': {
        return 'Pause';
      }
      case 'Unpause': {
        return 'Unpause';
      }
      case 'Unsnooze order': {
        return 'Unsnooze';
      }
      case 'Unmerge': {
        return 'Unmerge';
      }
    }
    return 'Confirm';
  }

  close() {
    if (!this.isLoading) {
      this.dialogRef.close();
    }
  }
}
